/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { textEditorInit } from "./modules/textEditor";
import { codeEditorInit } from "./modules/codeEditor";
// import {authInit} from "./modules/auth/auth";
// import {lazyLoadInit} from "./modules/lazyLoad";
import { listsInit, filterElementsInit } from "./modules/pagination";
import { saveFormInit } from "./modules/form";
import { formValidationInit } from "./modules/formValidation";
import { datetimePickerInit } from "./modules/dateTimePicker";
// import {durationPickerInit} from "./modules/durationPicker";
import { fileInputInit } from "./modules/fileInput";
import { customTabsInit } from "./modules/tabs";
import { generateSlugInit } from "./modules/url";
import { imageUploaderInit, dropzoneInit } from "./modules/images";
import { savePageFormInit } from "./modules/pageForm";
// import {modalInit} from "./modules/modal";
import { customSelectsInit } from "./modules/customSelects";
// import {searchBarInit} from "./modules/searchBar";
// import {importExportInit} from "./modules/importExport";
// import {saveBookInit} from "./action/book";
import { tooltip } from "./modules/utils/functions";
import { userMessageAssignInit } from "./modules/userMessage";
import { modalInit } from "./modules/modal";
import { menuInit } from "./modules/menu";
// import {consoleInit} from "./modules/console";
// import {formSelectInit} from "./components/form-selects";
// import {phonePickerInit} from "./components/phone-picker";
// import {creditCardFormatInit} from "./components/credit-card";
// import {jsonViewerInit} from "./components/json-viewer";
// import {imageUploadWidgetInit} from "./components/image-manager";
// import {jsonDiffInit} from "./components/json-diff";

document.addEventListener('DOMContentLoaded', function () {
  //==============OLD===================
  // formSelectInit();
  // formValidationInit();
  // datetimePickerInit();
  // phonePickerInit();
  // creditCardFormatInit();
  // jsonViewerInit();
  // fileInputInit();
  // codeEditorInit();
  // textEditorInit();
  // dropzoneInit();
  // imageUploadWidgetInit();
  // // customScrollbarInit();
  // jsonDiffInit();
  // filterElementsInit();
  // // console.info('dom ready');
  //==============OLD===================

  tooltip();
  // authInit();

  // searchBarInit();

  // lazyLoadInit();
  listsInit();
  modalInit();
  // popupSearchInit();
  saveFormInit();
  filterElementsInit();
  imageUploaderInit();
  dropzoneInit();
  customSelectsInit();
  formValidationInit();
  fileInputInit();
  textEditorInit();
  codeEditorInit();
  customTabsInit();
  generateSlugInit();
  // copyImagePath();
  // durationPickerInit();
  datetimePickerInit();

  // pages
  // saveBookInit();
  // barcodeGenerationInit();
  // bookLayoutInit();
  // setAndUpdateListInit();
  menuInit();
  // customFieldsInit();
  // borrowingInit();
  savePageFormInit();
  userMessageAssignInit();
  // consoleInit();
  // importExportInit();

  // ??

  // phonePickerInit();
  // creditCardFormatInit();
  // jsonViewerInit();

  // dropzoneInit();
  // imageUploadWidgetInit();
  // customScrollbarInit();
  // jsonDiffInit();
  // console.info('dom ready');
});